<template>
  <div class="home">
   <Cuento/>
  </div>
</template>

<script>
// @ is an alias to /src
import Cuento from '@/components/Cuento'

export default {
  name: 'Home',
  components: {
    Cuento
  }
}
</script>
